import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  IconButton,
  Typography,
} from '@material-ui/core';
import './index.scss';
import CloseIconModal from 'assets/icons/CloseIconModal';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { Row } from 'components/Row';
import { Col } from 'components/Col';
import { CustomCheckbox } from 'components/CustomCheckbox';
import useValidations from 'pages/Contratos/Fluxos/FluxoDescentralizados/hooks/useValidations';
import moment from 'moment';
import SnackbarUtils from 'utils/SnackbarUtils';
import {
  CONTRATO_ETAPAS_PARAMS_URL,
  CONTRATO_PASSOS,
  CONTRATO_FLUXO_DESCENTRALIZADO,
  ContratoStatus,
  VersaoContratoEnum,
  URL_DISTRATO_PARAM,
  URL_ENTE_DESCENTRALIZADO,
} from 'models/contratos';
import ModalConfirm from 'pages/Contratos/components/ModalConfirm';
import { openModal } from 'store/modules/ModalActions';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { newContratoDescentralizadoEditRoute } from 'library/Routes';
import {
  CreateRouteParams,
  EditRouteParams,
} from 'pages/Contratos/Fluxos/FluxoDescentralizados/__types';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { loadContratoAdendos } from 'store/modules/AllContratos/AllContratosActions';
import { changeContratoEntePrivadoEditingValue, closeModalEntePrivadoDistrato, contratoEntePrivadoDescentralizadoCreateDistrato, contratoEntePrivadoDescentralizadoEditDistrato, loadContratoEntePrivado } from 'store/modules/ContratosFluxoDescentralizado/EntePrivado/EntePrivadoActions';
import { loadAllProfessorGestorByEscola } from 'store/modules/ProfessoresActions';
import { CustomTextField } from 'components/CustomTextField';
import { DateMaskedInput } from 'components/MaskedInputs';

interface Escola {
  id: number;
  nome: string;
  coop?: string;
  cidadeNome?: string | null;
  estadoId?: string | null;
}

const ModalDistratoEntePrivado = () => {
  const [dataError, setDataError] = useState('');
  const languageValues = useSelector(
    (state: RootState) => state.languages.languageValues
  );
  const escolas = useSelector((state: RootState) => state.escolas);
  const contratosEntePrivadoReducer = useSelector(
    (state: RootState) => state.contratosDescentralizadosEntePrivado
  );
  const professoresReducer = useSelector((state: any) => state.professores)
  const adendosAll = useSelector(
    (state: RootState) => state.allContratos.adendosAll
  );
  const adendoVersaoContratoUm = adendosAll.find(
    (adendo) => adendo.versaoContrato === 1
  );
  const idVersaoContrato = adendoVersaoContratoUm
    ? adendoVersaoContratoUm?.id
    : null;
  const {
    isContratoAtivoEntePrivado,
    validDadosEntePrivadoDistrato,
    validateDateDistrato,
  } = useValidations();
  const location = useLocation();
  const params = useParams<CreateRouteParams & EditRouteParams>();
  const idContrato = params.id;
  const history = useHistory();
  const dispatch = useDispatch();

  const fluxoEntePrivado = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PRIVADO);

  const handleDataChange = useCallback(
    (name, value) => {
      dispatch(changeContratoEntePrivadoEditingValue(name, value));
    },
    [dispatch]
  );

  const fechaModalEAtualizaContrato = () => {
    history.push(
      newContratoDescentralizadoEditRoute.getURLWithParams(
        CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PRIVADO,
        CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
        idVersaoContrato,
        CONTRATO_PASSOS.DOCUMENTOS
      )
    );
    dispatch(closeModalEntePrivadoDistrato());
  };

  const verificaSeTemDistrato = () => {
    return adendosAll.some(
      (item) => item.versaoContrato === VersaoContratoEnum.DISTRATO
    );
  };
  const contenDistrato = verificaSeTemDistrato();

  const abrirModalCriacaoDistrato = () => {
    const fechaModal = !desabilitaCampos();
    const status = contratosEntePrivadoReducer.contratoEditing.flgStatus;

    if (fechaModal) {
      fechaModalEAtualizaContrato();
      return;
    }
    if (status === ContratoStatus.EM_EDICAO && contenDistrato === true) {
      submitDistrato();
      fechaModalEAtualizaContrato();
      return;
    }
    dispatch(
      openModal(ModalConfirm, {
        title: languageValues.criacaoDistrato,
        content: languageValues.confirmarCriacaoDistrato,
        confirmLabel: languageValues.confirmar,
        confirmCallback: () => {
          submitDistrato();
        },
        modalKey: 'modalComplete',
        maxWidth: 'sm',
      })
    );
  };

  const tituloModalDistrato = () => {
    const status = contratosEntePrivadoReducer.contratoEditing.flgStatus;
    const url = window.location.href;

    if (url.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO)) {
      switch (status) {
        case ContratoStatus.ENCERRADO:
        case ContratoStatus.NAO_INICIADO:
        case ContratoStatus.VIGENTE:
        case ContratoStatus.AGUARDANDO_EXTRATO:
          return `${languageValues.distrato}`;
        default:
          return `${languageValues.editarDistrato}`;
      }
    }

    return languageValues.criacaoDistrato;
  };

  const desabilitaCampos = () => {
    const isCriacao = location.pathname.includes(URL_DISTRATO_PARAM.CADASTRO_DISTRATO);
    const { flgStatus, flgAtivo } = contratosEntePrivadoReducer.contratoEditing;
    if (!flgAtivo) {
      return false;
    }
    if (!isCriacao) {
      switch (flgStatus) {
        case ContratoStatus.ENCERRADO:
        case ContratoStatus.VIGENTE:
        case ContratoStatus.NAO_INICIADO:
        case ContratoStatus.AGUARDANDO_EXTRATO:
          return false;
        default:
          return true;
      }
    }
    return true;
  };

  const handleEscolaChange = (value: { value: string, label: string }) => {
    const currValue = value ? value.value : '';
    handleDataChange('nomEscola', currValue);
    handleDataChange('idEscola', currValue)
  };

  const handleRepresentanteChanged = (value: { value: string }) => {
    const currValue = value ? value.value : '';
    handleDataChange('cpfProfessor', currValue);
  }

  const getEscolas = (): Escola[] => {
    if (contratosEntePrivadoReducer.contratoEditing.nomCidade) {
      return (escolas.escolasPorCidade as unknown as Escola[]) || [];
    }
    if (idContrato) {
      return contratosEntePrivadoReducer.contratoEditing.nomEscola ? [{
        nome: contratosEntePrivadoReducer.contratoEditing.nomEscola,
        id: contratosEntePrivadoReducer.contratoEditing.idEscola
      }] : [];
    }
    return [];
  };

  const getRepresentantes = () => {
    if (contratosEntePrivadoReducer.contratoEditing.cpfProfessor) {
      return professoresReducer.professoresGestoresByEscola || [];
    }
    if (contratosEntePrivadoReducer.contratoEditing.idEscola) {
      return professoresReducer.professoresGestoresByEscola || [];
    }
    return [];
  };

  const desabilitaCampoEscola = () => {
    return true;
  }

  const desabilitaCampoRepresentantes = () => {
    return true;
  }

  const submitDistrato = async () => {
    const isEdicaoDistrato = location.pathname.includes(
      URL_DISTRATO_PARAM.EDICAO_DISTRATO
    );
    const isVersaoDistrato = location.pathname.includes(
      URL_DISTRATO_PARAM.VERSAO
    );
    const isCriacao = location.pathname.includes(
      URL_DISTRATO_PARAM.CADASTRO_DISTRATO
    );
    const distratoData = {
      idContrato: idVersaoContrato,
      idEstado: contratosEntePrivadoReducer.contratoEditing.idEstado,
      nomCidade: contratosEntePrivadoReducer.contratoEditing.nomCidade,
      dataDistrato: moment(contratosEntePrivadoReducer.contratoEditing.dataDistrato, 'DD MM YYYY').format('YYYY-MM-DD'),
      flgAnaliseJuridica: contratosEntePrivadoReducer.contratoEditing.flgAnaliseJuridica,
      totalMeses: contratosEntePrivadoReducer.contratoEditing.totalMeses,
      versaoContrato: VersaoContratoEnum.DISTRATO
    };
    const data = { ...distratoData };
    try {
      if (isVersaoDistrato && isEdicaoDistrato) {
        data.idContrato = idVersaoContrato;
        dispatch(
          contratoEntePrivadoDescentralizadoEditDistrato(
            Number(params.idDistrato),
            data,
            () => {
              SnackbarUtils.enqueueSnackbar({
                message: languageValues.successContratoDistratoAtualizar,
                options: {
                  variant: 'success',
                },
              });
              fechaModalEAtualizaContrato();
            },
            (error) => {
              const errorMessage = error.response?.data?.message;
              SnackbarUtils.enqueueSnackbar({
                message: errorMessage,
                options: {
                  variant: 'error',
                },
              });
            }
          )
        );
      } else if (isCriacao && (contenDistrato || !contenDistrato)) {
        data.idContrato = idVersaoContrato;
        dispatch(
          contratoEntePrivadoDescentralizadoCreateDistrato(
            data,
            () => {
              SnackbarUtils.enqueueSnackbar({
                message: languageValues.successContratoDistratoSalvar,
                options: {
                  variant: 'success',
                },
              });
              fechaModalEAtualizaContrato();
              dispatch(loadContratoAdendos(idVersaoContrato));
            },
            (error) => {
              const errorMessage = error.response?.data?.message;
              SnackbarUtils.enqueueSnackbar({
                message: errorMessage,
                options: {
                  variant: 'error',
                },
              });
            }
          )
        );
      }
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message: error,
        options: {
          variant: 'error',
        },
      });
    }
  };

  useEffect(() => {
    if (fluxoEntePrivado &&
      (location.pathname.includes(URL_DISTRATO_PARAM.CADASTRO_DISTRATO) ||
        location.pathname.includes(URL_DISTRATO_PARAM.MODAL_CRIACAO_DISTRATO))) {
      dispatch(loadContratoEntePrivado(Number(params.id), VersaoContratoEnum.CONTRATO));
    }
    // eslint-disable-next-line 
  }, [dispatch,
    location.pathname])

  useEffect(() => {
    if (fluxoEntePrivado &&
      (location.pathname.includes(URL_DISTRATO_PARAM.MODAL_EDICAO_DISTRATO) ||
        location.pathname.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO))) {
      dispatch(loadContratoEntePrivado(Number(params.idDistrato), VersaoContratoEnum.DISTRATO));
    }
    // eslint-disable-next-line
  }, [
    dispatch,
    location.pathname]);

  useEffect(() => {
    if (fluxoEntePrivado &&
      (location.pathname.includes(URL_DISTRATO_PARAM.MODAL_EDICAO_DISTRATO) ||
        location.pathname.includes(URL_DISTRATO_PARAM.MODAL_CRIACAO_DISTRATO) ||
        location.pathname.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO) ||
        location.pathname.includes(URL_DISTRATO_PARAM.CADASTRO_DISTRATO)
      )) {
      const idEscola = contratosEntePrivadoReducer.contratoEditing.idEscola
      if ((location.pathname.includes(URL_DISTRATO_PARAM.CADASTRO_DISTRATO) ||
        location.pathname.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO)) &&
        idEscola) {
        dispatch(loadAllProfessorGestorByEscola(idEscola));
      }
    }
    // eslint-disable-next-line 
  }, [contratosEntePrivadoReducer.contratoEditing.idEstado, dispatch, location.pathname])

  return (
    <>
      <Dialog
        open={contratosEntePrivadoReducer.isModalDistratoOpen}
        aria-labelledby='form-dialog-distrato'
        className='form-dialog-distrato'
        TransitionComponent={Fade}
        transitionDuration={{
          enter: 350,
        }}
        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
      >
        <DialogTitle className='form-dialog-distrato__title-modal'>
          <div className='form-dialog-distrato__titleContainer'>
            <Typography className='form-dialog-distrato__titleModal'>
              {tituloModalDistrato()}
            </Typography>
            <IconButton
              aria-label='close'
              className='form-dialog-distrato__closeButton'
              onClick={() => fechaModalEAtualizaContrato()}
            >
              <CloseIconModal />
            </IconButton>
          </div>
          <div className='form-dialog-distrato__titleLine'></div>
        </DialogTitle>
        <DialogContent>
          <Box className='form-dialog-distrato__box'>
            <Card className='form-dialog-distrato__card'>
              <Box>
                <Row>
                  <Col cols={[12, 12, 12, 12, 12]}>
                    <Typography
                      variant='h5'
                      id='dadosEntePrivado'
                      className='form-dialog-distrato__tipo-contrato-title'
                    >
                      {languageValues.cadastroContratoDadosEntePrivado}
                    </Typography>
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <NewAutoCompleteField
                      id="nomEscola"
                      label={languageValues.escola}
                      options={getEscolas().map((item: Escola) => ({
                        label: item.nome,
                        value: item.id,
                      }))}
                      value={contratosEntePrivadoReducer.contratoEditing.idEscola}
                      onChange={handleEscolaChange}
                      disabled={desabilitaCampoEscola() || !isContratoAtivoEntePrivado()}
                    />
                  </Col>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <NewAutoCompleteField
                      id={'representanteGestor'}
                      label={languageValues.representantesLabel}
                      options={getRepresentantes().map((item: { nome: string, cpf: string }) => ({
                        label: item.nome,
                        value: item.cpf,
                      }))}
                      value={contratosEntePrivadoReducer.contratoEditing.cpfProfessor}
                      onChange={handleRepresentanteChanged}
                      disabled={desabilitaCampoRepresentantes() || !isContratoAtivoEntePrivado()}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 12, 12, 12]}>
                    <Typography
                      variant='h5'
                      id='dadosEntePrivado'
                      className='form-dialog-distrato__tipo-contrato-title'
                    >
                      {languageValues.cadastroContratoDadosContratoDistrato}
                    </Typography>
                  </Col>
                </Row>

                <Row>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <CustomTextField
                    id={'data-distrato'}
                    label={languageValues.cadastroContratoDataDistrato}
                    name='dataDistrato'
                    value={
                      contratosEntePrivadoReducer.contratoEditing.dataDistrato
                    }
                    onChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                      const value = event.target.value.trim();
                      const validation = validateDateDistrato(value);
                      setDataError(validation.error);
                      handleDataChange('dataDistrato', value);
                    }}
                    helperText={dataError ? dataError : ''}
                    error={dataError !== ''}
                    InputProps={{ inputComponent: DateMaskedInput }}
                    disabled={!desabilitaCampos()}
                  />
                  </Col>
                </Row>

                <Row className='form-dialog-distrato__row-content'>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <div className='form-dialog-distrato__label-total-meses'>
                      {languageValues.totalMesesContratados}
                    </div>
                    <div className='form-dialog-distrato__value-total-meses'>
                      {isNaN(
                        Number(contratosEntePrivadoReducer.contratoEditing.totalMeses)
                      )
                        ? 0
                        : Number(
                          contratosEntePrivadoReducer.contratoEditing.totalMeses
                        ).toString()}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <CustomCheckbox
                      id={'analise-juridica'}
                      className={'form-dialog-distrato__analise-juridica'}
                      label={languageValues.flgAnaliseJuridicaAceite}
                      name='flgAnaliseJuridica'
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        handleDataChange(
                          'flgAnaliseJuridica',
                          event.target.checked
                        );
                      }}
                      checked={
                        contratosEntePrivadoReducer.contratoEditing
                          .flgAnaliseJuridica
                      }
                      disabled={!desabilitaCampos()}
                    />
                  </Col>
                </Row>
              </Box>
            </Card>
          </Box>
        </DialogContent>
        <DialogActions className='form-dialog-distrato__dialog-actions'>
          <Button
            className='form-dialog-distrato__btnClose'
            onClick={() => fechaModalEAtualizaContrato()}
          >
            {languageValues.cancelButton}
          </Button>
          <Button
            className='form-dialog-distrato__btnSave'
            onClick={() => abrirModalCriacaoDistrato()}
            disabled={!validDadosEntePrivadoDistrato()}
          >
            {languageValues.concluir}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default React.memo(ModalDistratoEntePrivado);

